function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHideRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.203 23.797c-7.102 0-10.721-5.875-11.797-8 .633-1.249 2.149-3.78 4.719-5.664l2.91 2.91a4.964 4.964 0 00-.832 2.754 5 5 0 005 5 4.972 4.972 0 002.754-.832l2.571 2.571a11.661 11.661 0 01-5.325 1.261zm0-16c7.102 0 10.721 5.876 11.797 8-.633 1.25-2.149 3.78-4.719 5.664l-2.91-2.91c.523-.79.832-1.735.832-2.754a5 5 0 00-5-5 4.964 4.964 0 00-2.754.832l-2.57-2.57a11.654 11.654 0 015.324-1.262zm2.699 9.285L16.91 15.09l-1.992-1.993c.391-.187.823-.3 1.285-.3 1.654 0 3 1.346 3 3 0 .461-.114.894-.301 1.285zm-5.399-2.57l3.985 3.984a2.968 2.968 0 01-1.285.301c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285zm16.903 14.074l-5.703-5.703c3.842-2.952 5.5-7.086 5.5-7.086s-4-10-14-10c-2.689 0-4.941.727-6.801 1.784L3.414 1.594 2 3.008l5.703 5.703c-3.842 2.952-5.5 7.086-5.5 7.086s4 10 14 10c2.689 0 4.941-.727 6.802-1.784L28.992 30l1.414-1.414z",
    fill: props.color
  }));
}

export default SvgIconHideRexOutline;